"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRequestStatuses = void 0;

var getRequestStatuses = function getRequestStatuses(state) {
  return state.requests;
};

exports.getRequestStatuses = getRequestStatuses;